import React from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import {
  Alert,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  ButtonGroup,
  Label,
  Input,
  Collapse
} from 'reactstrap';
import uuidv4 from 'uuid/v4';
import classNames from 'classnames';
import moment from 'moment-timezone';
import {
  upload,
  newSlider,
  saveSlider,
  deleteSlider,
  getDetailSlider,
  storeSliderImages
} from '../../actions/sliderAction';
import {
  getOptionList as getCategoryOptionList
}
from '../../actions/categoriesAction';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { FontAwesomeIcon } from '../../components/Icons';
import CardLoadingPlaceholder from '../../components/Card/CardLoadingPlaceholder';
import InputDatetime from '../../components/Form/InputDatetime/InputDatetime';
import { ButtonLoading } from '../../components/Button';
import { Radio, RadioText, FormGroupRadio } from '../../components/Form/Radios';
import { ModalDelete, ModalEditImage, ModalBlockLoading as ModalLoading } from '../../components/Modals';
import { isRequired } from '../../helpers/regex';
import { getPathS3 } from '../../utils/AWS';
import { addErrorMessage, errorMessage, hasError, textValue } from '../../utils/form';
import { uploadImage, deleteImage } from '../../actions/imageUploadAction';
import { getOriginFromSignedUrl } from '../../utils/AWS';
import { ImageFile } from '../../components/Images';
import { DropzonePlusButton } from '../../components/Form/DropzoneFile';
import { ImagesCompressor, readFile, createUploadFileForm } from '../../utils/imageHelper';

const sliderPlatformOptions = [{
  value: "", label: "Web & App"
},{
  value: "APP", label: "Only App"
},{
  value: "WEB", label: "Only Web"
}];

const addImageRawObject = file => {
  return {
    status: false,
    identifier: uuidv4(),
    fileInput: file,
    is_uploading: false
  }
}

const visibleOnApp = value =>
  value === null || value === '' || value === 'APP'


const SUBMIT_UPLOAD_DEFAULT_IMG_STATUS = 'SUBMIT_UPLOAD_DEFAULT_IMG_STATUS';
const SUBMIT_UPLOAD_IMAGES_STATUS = 'SUBMIT_UPLOAD_IMAGES_STATUS';
const SUBMIT_SLIDER_FORM_STATUS = 'SUBMIT_SLIDER_FORM_STATUS';
const DELETE_SLIDER_FORM_STATUS = 'DELETE_SLIDER_FORM_STATUS';
const DEFAULT_IMAGE_ASPECT_LANDSCAPE = 16/5;
const DEFAULT_IMAGE_ASPECT_PORTRAIT = 1/1;
class VideoForm extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      id: 0,
      name: '',
      active: 0,
      category_id: '',
      img_url: '',
      video_url: '',
      platform: '',
      order: 1,
      started_at: '',
      ended_at: '',
      created_at: '',
      updated_at: '',
      _formSubmit: false,
      _error: null,
      isEditImageOpen: false,
      editImageRatio: DEFAULT_IMAGE_ASPECT_LANDSCAPE,
      imageSourceToEdit: null,
      imageSourceToEdits: [],
      imageSourceReferer: null, //'default' or 'childs'
      _initFetch: true,
      _rawImage: null,
      _rawImages: [],
      _uploadCounter: 0,
      _submitFormStatus: null,
      _isSuccessSubmitAlertOpen: false,
      _isSuccessUploadDefaultImgAlertOpen: false,
      _isModalDeleteOpen: false,
    };
    this._handleOnChange = this._handleOnChange.bind(this);
  }

  componentDidMount(){
    const { match } = this.props;
    if(match && match.params.id){
      this.props.find(match.params.id);
    }
    this.props.bindCategoryOption();
  }

  componentWillUnmount(){
    this.props.new();
  }

  async componentDidUpdate(prevProps){
    const { match } = this.props;
    const { isFetch, isSubmit } = this.props.slider;
    const { isFetch: prevIsFetch, isSubmit: prevIsSubmit } = prevProps.slider;
    if(isFetch !== prevIsFetch && !isFetch){
      const { detail, error } = this.props.slider;
      if(!error && match && match.params.id){
        const { _submitFormStatus, _initFetch } = this.state;
        if(_initFetch){
          const appImage = detail.images.length? {
            id: detail.images[0].id,
            URL: detail.images[0].signed_url? detail.images[0].signed_url: detail.images[0].URL,
            imgUrl: detail.images[0].signed_url?  detail.images[0].signed_url: detail.images[0].URL,
            orientation: detail.images[0].orientation,
            raw: null
          }: null
          this.setState({
            _formSubmit: false,
            _rawImage: null,
            _appImage: appImage,
            _initFetch: false,
            ...this._bindDataApi()
          })
        }
        else if(_submitFormStatus === 'SYNC_IMAGES'){
          const appImage = detail.images.length? {
            id: detail.images[0].id,
            URL: detail.images[0].signed_url? detail.images[0].signed_url: detail.images[0].URL,
            imgUrl: detail.images[0].signed_url?  detail.images[0].signed_url: detail.images[0].URL,
            orientation: detail.images[0].orientation,
            raw: null
          }: null;
          this.setState({
            id: detail.id,
            _appImage: appImage,
            _formSubmit: false,
            _rawImages: [],
            _isModalLoadingOpen: false,
            _submitFormStatus: null
          })
        }
      }
      else{
        this.setState({
          _formSubmit: false,
          _isModalLoadingOpen: false,
          _error: { ...error }
        });
      }
    }
    if(isSubmit !== prevIsSubmit && !isSubmit && this.state._formSubmit){
      const { detail, error } = this.props.slider;
      if(error){
        this.setState({
          _formSubmit: false,
          _error: { ...error }
        })
      }else{
        const { oldImageUrl, _rawImage, _submitFormStatus } = this.state;
        if(this.state.img_url !== oldImageUrl && _rawImage !== null && _submitFormStatus !== SUBMIT_UPLOAD_DEFAULT_IMG_STATUS){
          const fileInput =  await this._compressImage(_rawImage.fileInput)
          await this.setState({
            _rawImage: {
              ...this.state._rawImage,
              fileInput,
              is_uploading: true
            },
            _isModalLoadingOpen: true,
            _submitFormStatus: SUBMIT_UPLOAD_DEFAULT_IMG_STATUS
          },()=>{
            const { oldFileName } = this.state;
            const name = oldFileName? oldFileName: `video-images/${detail.id}`;
            const tempPayload = createUploadFileForm(fileInput, false, {name, bucket_type: "assets"});
            this.props.uploadImage(tempPayload, _rawImage);
          })
        }
        else{
          const rawImages = await this._compressImgsProgress()
          if(match.params.id != detail.id && !rawImages.length){
            this.props.history.replace(`/videos/${detail.id}`)
          }
          else if(detail.delete === true){
            this.props.history.replace(`/videos`)
          }
          else{
            await this.setState({
              _formSubmit: rawImages.length? true: false,
              _isModalLoadingOpen: rawImages.length? true: false,
              _submitFormStatus: rawImages.length? SUBMIT_UPLOAD_IMAGES_STATUS: null,
              _uploadCounter: 0,
              _rawImage: null,
              _isSuccessSubmitAlertOpen: true,
              ...this._bindDataApi()
            })
            if(rawImages.length){
              const tempPayload = createUploadFileForm(rawImages[0].fileInput, false, {name: "video-images/"+detail.id, bucket_type: "assets"});
              this.props.uploadImage(tempPayload, rawImages);
            }
          }
        }
      }
    }
    if(prevProps.slider.images.isSubmit !== this.props.slider.images.isSubmit
      && !this.props.slider.images.isSubmit){
      const { error } = this.props.slider.images;
      const { id } = this.state;
      if(this.props.match.params.id != id){
        this.props.history.replace(`/videos/${id}`)
      }
      if(error){
        this.setState({
          _error: {
            status_code: 500,
            message: "Failed to connect our api."
          },
          _formSubmit: false,
          _isModalLoadingOpen: false,
          _submitFormStatus: null
        });
      } else{
        this.setState({
          _rawImages: [],
          _submitFormStatus: 'SYNC_IMAGES'
        })
        this.props.find(id)
      }
    }
    if(this.state._submitFormStatus === SUBMIT_UPLOAD_DEFAULT_IMG_STATUS && prevProps.dataUploaded.isUpload 
      && prevProps.dataUploaded.isUpload !== this.props.dataUploaded.isUpload){
      const { success, error } = this.props.dataUploaded;
      const hasPendingUploads = this.state._uploadCounter + 1 < this.state._rawImages.length;
      const nextUpload = this.state._uploadCounter + 1;
      if(error){
        await this.setState({
          _formSubmit: false,
          _rawImages: this.state._rawImages.map((r, key) => {
            if(key === this.state._uploadCounter){
              return{
                ...r,
                is_uploading: false,
                is_error: true
              }
            } else if(hasPendingUploads && key === nextUpload){
              return {
                ...r,
                is_uploading: true
              }
            }
            return { ...r }
          }),
          _isModalLoadingOpen: hasPendingUploads,
          _submitFormStatus: hasPendingUploads? SUBMIT_UPLOAD_IMAGES_STATUS: null,
          _uploadCounter: hasPendingUploads? nextUpload : 0,
          _error: {
            status_code: 500,
            message: 'Failed connect to s3.'
          }
        });

        if(hasPendingUploads){
          const { id, _rawImages } = this.state;
          const tempPayload = createUploadFileForm(_rawImages[nextUpload], false, {name: "video-images/"+id, bucket_type: "assets"});
          this.props.uploadImage(tempPayload, _rawImages);
        }
      }
      if(!error){
        const { detail } = this.props.slider;
          if(success.data){
          const { _rawImage } = this.state;
            if(_rawImage.identifier === success.data.identifier){
              this.setState({
                id: detail.id,
                img_url: success.data.url,
                _rawImage: null,
                oldImageUrl: success.data.url,
                oldFileName: this._getFileName(success.data.url),
                _isSuccessUploadDefaultImgAlertOpen: true
              }, ()=>{
                this._submitToApi();
              });
            }
        }
      }
    }
    if(this.state._submitFormStatus === SUBMIT_UPLOAD_IMAGES_STATUS && prevProps.dataUploaded.isUpload 
      && prevProps.dataUploaded.isUpload !== this.props.dataUploaded.isUpload){
        const { success, error } = this.props.dataUploaded;
        if(error){
          await this.setState({
            _formSubmit: false,
            _isModalLoadingOpen: false,
            _submitFormStatus: null,
            _uploadCounter:0,
            _error: {
              status_code: 500,
              message: 'Failed connect to s3.'
            }
          });
        }
        if(!error){
          const { data } = success.data;
          if(Object.keys(data).length){
            const { _rawImages, _appImage, id } = this.state;
            data.map(item => {
              if(_rawImages[0].identifier === item.identifier){
                const isAppImage = _appImage && _appImage.raw !== null && _appImage.raw.identifier === item.identifier;
                const payloads = isAppImage? {
                  id: _appImage.id,
                  orientation:item.orientation,
                  url:item.url
                }:{ images: [{url : item.url, orientation : item.orientation}]};
                this.props.storeSliderImages(id, payloads)
              }
            })
          }
          else{
            this.setState({ _formSubmit: false, _isModalLoadingOpen: false })
          }
        }
    }
    if(prevProps.dataUploaded.isDeleteProgress && prevProps.dataUploaded.isDeleteProgress !== this.props.dataUploaded.isDeleteProgress) {
      const { deleted, error } = this.props.dataUploaded;
      const { id, _formSubmit, _appImage } = this.state;
      this.props.delete(id)
      if(error){
        if(_formSubmit){
          if(_appImage && _appImage.imgUrl){
            const payload = {
              bucket_type : 'assets',
              name : getPathS3(getOriginFromSignedUrl(_appImage.imgUrl))
            };
            this.props.deleteImage(payload);
          }
        }
        else{
          this.setState({
            _submitFormStatus: false,
            _isModalLoadingOpen: false,
            _submitFormStatus: null,
            _uploadCounter:0,
            _error: {
              status_code: 500,
              message: 'Failed delete img.'
            }
          })
        }
      }
      if(_formSubmit && !error && deleted.data){
        if(_appImage && _appImage.imgUrl){
          const payload = {
            bucket_type : 'assets',
            name : getPathS3(getOriginFromSignedUrl(_appImage.imgUrl))
          };
          this.props.deleteImage(payload);
        }
      }
    }
  }

  _getFileName = s3Link =>{
    const file = getPathS3(s3Link);
    const hasUploaded = file !== null;
    return hasUploaded? file.replace(/^\/video-images\//, ''): null;
  }

  _bindDataApi = () => {
    const { detail } = this.props.slider;
    const fileName = this._getFileName(detail.img_url||'');
    const startAtParsed = moment(detail.started_at, 'YYYY-MM-DD');
    const endedAtParsed = moment(detail.ended_at, 'YYYY-MM-DD');
    const payloads = {
      id: detail.id,
      name: detail.name,
      active: detail.active,
      category_id: detail.category_id,
      img_url: detail.signed_url? detail.signed_url: detail.img_url,
      oldImageUrl: detail.signed_url? detail.signed_url: detail.img_url,
      oldFileName: fileName,
      video_url: detail.redirect_url,
      platform: detail.platform||'',
      order: detail.order,
      started_at: startAtParsed.isValid()? startAtParsed: '',
      ended_at: endedAtParsed.isValid()? endedAtParsed: '',
      created_at: detail.created_at,
      updated_at: detail.updated_at,
    }
    return payloads;
  }

  _handleOnChange(value) {
    this.setState({ tags:value });
  }

  _handleInputChange = ({ target: { name, value, checked, type } }) => {
    this.setState({ [name]: type === 'checkbox'? checked: value })
  }

  _handleSelectChange = (name, val) => {
    this.setState({ [name]: val? val.value: null })
  }


  _hasError = name => {
    const { _error } = this.state;
    return _error && _error.errors && hasError(name, _error)
  }

  _renderErrorMessage = name => {
    const { _error } = this.state;
    return errorMessage(name, _error)
  }

  _compressImgsProgress = async () => {
    const { _rawImages } = this.state;
    const rawImagesPromises = _rawImages.map(async(r, key) => {
      const fileInput =  await this._compressImage(r.fileInput)
      return {
        ...r,
        is_uploading: key === 0,
        fileInput
      }
    });
    return await Promise.all(rawImagesPromises)
  }

  _uploadImgsProgress = (id, commpressImages) => {
    if(commpressImages.length){
      this.setState({
        id: id,
        _isModalLoadingOpen: true,
        _rawImages: [...commpressImages],
        _formSubmit: true,
        _submitFormStatus: SUBMIT_UPLOAD_IMAGES_STATUS,
        _uploadCounter: 0
      })
      this.props.upload(commpressImages[0], `video-images/${id}/`)
    }
  }

  _compressImage = async (image) => {
    let fileInput = image
    try{
      //compress file
      fileInput = await ImagesCompressor(image);
    }
    catch(e){
      alert('error while compress the images')
      fileInput = image
    }
    return fileInput;
  }


  _handleDropzoneChange = async (files, type) => {
    if(files.length){
      if(type === 'default'){
        const [file] = files;
        const imageDataUrl = file.preview;
        this.setState({
          _rawImage: addImageRawObject(file),
          img_url: imageDataUrl,
          isEditImageOpen: true,
          imageSourceToEdit: imageDataUrl,
          imageSourceReferer: 'default',
          editImageRatio: DEFAULT_IMAGE_ASPECT_LANDSCAPE
        });
      }
      else if(type === 'app_image'){
        const [file] = files;
        const imageDataUrl = file.preview;
        const obj = addImageRawObject(file)
        const { _appImage } = this.state;
        this.setState({
          _appImage: _appImage? {
            ..._appImage,
            imgUrl: imageDataUrl,
            raw: {...obj}
          }: {
            id: 0,
            imgUrl: imageDataUrl,
            raw: {...obj}
          },
          _rawImages: [obj],
          isEditImageOpen: true,
          imageSourceToEdits: [{identifier: obj.identifier, imageDataUrl}],
          imageSourceToEdit: imageDataUrl,
          imageSourceReferer: 'app_image',
          editImageRatio: DEFAULT_IMAGE_ASPECT_PORTRAIT
        });
      }
      else if(type === 'multiple'){
        let fileList = [];
        let rawFiles = [];
        for(let i=0;i< files.length;i++){
          fileList.push(files[i])
        }
        for(let i=0;i<fileList.length;i++){
          const file = fileList[i];
          const imageDataUrl = await readFile(file)
          rawFiles.push({
            ...addImageRawObject(file),
            imageDataUrl
          })
        }
        if(rawFiles.length){
          const { _rawImages } = this.state;
          this.setState({
            _rawImages: [..._rawImages, ...rawFiles],
            isEditImageOpen: true,
            imageSourceToEdits: rawFiles.map(({identifier, imageDataUrl}) => ({identifier, imageDataUrl})),
            imageSourceToEdit: rawFiles[0].imageDataUrl,
            imageSourceReferer: 'childs',
            editImageRatio: DEFAULT_IMAGE_ASPECT_PORTRAIT
          });
        }
      }
    }
  }

  _handleToggleEditImageCallback = () => {
    const { imageSourceToEdits, isEditImageOpen } = this.state;
    if(!isEditImageOpen){
      let slices = []
      if(imageSourceToEdits.length>1){
        slices = imageSourceToEdits.slice(1).map(({identifier, imageDataUrl}) => ({identifier, imageDataUrl}))
      }
      if(slices.length){
        setTimeout(() => {
          this.setState({
            isEditImageOpen: !this.state.isEditImageOpen,
            imageSourceToEdits: [...slices],
            imageSourceToEdit: slices.length? slices[0].imageDataUrl: null
          })
        }, 1500);
      } else{
        this.setState({
          imageSourceToEdits: [],

          imageSourceToEdit: null
        })
      }
    }
  }

  _validateForm = async () => {
    const {
      name,
      img_url,
      video_url,
      category_id,
    } = this.state;
    let errors={};
    if(!isRequired(name))
      errors['name'] = addErrorMessage(errors, 'name', 'The name field is required.');
    if(!isRequired(category_id))
      errors['category_id'] = addErrorMessage(errors, 'category_id', 'Please select category.');
    if(!isRequired(img_url))
      errors['img_url'] = addErrorMessage(errors, 'img_url', 'Please upload any image.');
    if(!isRequired(video_url))
      errors['video_url'] = addErrorMessage(errors, 'video_url', 'The redirect url field is required.');
    if(Object.keys(errors).length){
      await this.setState({
        _error: {
          errors: { ...errors },
          status_code: 422,
          message: 'Please full fill form'
        }
      });
    } else{
      await this.setState({ _error: null })
    }
    return Object.keys(errors).length? errors: null;
  }

  _submitToApi = () => {
    const payloads = {
      category_id: this.state.category_id,
      name: this.state.name,
      type: 'VIDEO',
      active: this.state.active,
      img_url: getOriginFromSignedUrl(this.state.oldImageUrl),
      redirect_url: this.state.video_url,
      order: Number(this.state.order),
      platform: this.state.platform === ''? null: this.state.platform,
      started_at: this.state.started_at === ''? null: (
        moment.isMoment(this.state.started_at)? this.state.started_at.format("YYYY-MM-DD"): this.state.started_at),
      ended_at: this.state.ended_at === ''? null: (
        moment.isMoment(this.state.ended_at)? this.state.ended_at.format("YYYY-MM-DD"):this.state.ended_at),
    }
    this.setState({
      _submitFormStatus: SUBMIT_SLIDER_FORM_STATUS
    });
    if(this.state.id > 0){
      this.props.save({ ...payloads, id: this.state.id })
    } else{
      this.props.save({ ...payloads })
    }
  }

  _handleSubmit = async (e) => {
    e.preventDefault();
    const err = await this._validateForm()
    const { _validateRedirectUrlInput } = this.state;
    const { productVariant: { isFetch } } = this.props;
    if(_validateRedirectUrlInput || isFetch) return;
    if(!err){
      this.setState({ _formSubmit: true }, async() =>{
        const { oldImageUrl, oldFileName, _rawImage } = this.state;
        if(!this.props.match.params.id && this.state.img_url !== oldImageUrl && _rawImage !== null){
          const fileInput =  await this._compressImage(_rawImage.fileInput)
          await this.setState({
            _rawImage: {
              ...this.state._rawImage,
              fileInput,
              is_uploading: true
            },
            _isModalLoadingOpen: true,
            _submitFormStatus: SUBMIT_UPLOAD_DEFAULT_IMG_STATUS
          })
          const name = oldFileName? oldFileName: `video-images`;
          const tempPayload = createUploadFileForm(fileInput, false, {name, bucket_type: "assets"});
          this.props.uploadImage(tempPayload, _rawImage);
        } else{
          this._submitToApi();
        }
      })
    }
  }

  _handleDatePickerChange = (date, name) => {
    this.setState({ [name]: date })
  }

  _renderLoading(){
    const { _submitFormStatus, _formSubmit } = this.state;
    if(!_submitFormStatus || !_formSubmit) return null;
    return (
      <Row>
        <Col xs={12}>
          <Alert color="info">
            <strong>Heads up!</strong> {
              _submitFormStatus === DELETE_SLIDER_FORM_STATUS? 'Deleting your data...': 'Submitting your data...'}
          </Alert>
        </Col>
      </Row>
    )
  }

  _renderError(){
    const { _error } = this.state;
    if(!_error) return null;
    const { status_code, message } = _error
    let messageStr = message;
    switch(status_code){
      case 422: messageStr = 'Please fullfill your form.'; break;
      case 404: messageStr = 'Resource not found.'; break;
      default: messageStr = "We've got something errors"; break;
    }
    return (
      <Row>
        <Col xs={12}>
          <Alert color="danger">
            <strong>Oh Snap!</strong> { messageStr }
          </Alert>
        </Col>
      </Row>
    )
  }
  
  _handleModalDeleteToggle = () => {
    this.setState({
      _isModalDeleteOpen: !this.state._isModalDeleteOpen
    })
  }

  _handleDeleteSlider = () =>{
    const { id, _formSubmit, img_url } = this.state;
    if(!_formSubmit){
      this.setState({
        _formSubmit: !_formSubmit,
        _submitFormStatus: DELETE_SLIDER_FORM_STATUS,
      })
      if(img_url){
        const payload = {
          bucket_type : 'assets',
          name : getPathS3(getOriginFromSignedUrl(img_url))
        };
        this.props.deleteImage(payload);
      }
      else
        this.props.delete(id)
    }
    this._handleModalDeleteToggle();
  }

  render(){
    const { isFetch: isLoading } = this.props.slider;
    return(
      <div className="animated fadeIn">
        <ModalLoading isOpen={this.state._isModalLoadingOpen}/>
        <ModalDelete
          isOpen={this.state._isModalDeleteOpen}
          modalTitle="Confirmation."
          modalBody="Are you sure to delete this?"
          onDelete={this._handleDeleteSlider}
          toggle={this._handleModalDeleteToggle}
        />
        <ModalEditImage
          isOpen={this.state.isEditImageOpen}
          imageSource={this.state.imageSourceToEdit}
          showGrid
          ratio={this.state.editImageRatio}
          onCropSucceeded={async(blob, ratio) => {
            const blobUrl = URL.createObjectURL(blob);
            let fileName = blobUrl.substr(blobUrl.lastIndexOf('/')+1)
            if(fileName == '') fileName = 'local'
            const { imageSourceReferer } = this.state;
            if(imageSourceReferer === 'default'){
              this.setState({
                _rawImage:{
                  ...this.state._rawImage,
                  fileInput: new File([blob], `${fileName}.jpeg`, {
                    type: 'image/jpeg'
                  })
                },
                isEditImageOpen: !this.state.isEditImageOpen,
                img_url: blobUrl,
                imageSourceToEdit: null
              })
            } else{
              const { _rawImages, imageSourceToEdits, _appImage } = this.state;
              let identifier = 0;
              if(imageSourceToEdits.length)
                identifier = imageSourceToEdits[0].identifier;
              const newRawImages = _rawImages.map(item => {
                if(item.identifier === identifier){
                  return {
                    ...item,
                    fileInput: new File([blob], `${fileName}.jpeg`, {
                      type: 'image/jpeg'
                    }),
                    imageDataUrl: blobUrl,
                    orientation: ratio.ratio <=1? 'portrait': 'landscape'
                  }
                }
                return item;
              });
              const isAppImage = imageSourceReferer === 'app_image' && _appImage && _appImage.raw;
              this.setState({
                _appImage: isAppImage? {
                  ..._appImage,
                  imgUrl: blobUrl,
                  raw:{
                    ..._appImage.raw,
                    ...newRawImages[0]
                  }
                }: _appImage,
                _rawImages: [...newRawImages],
                isEditImageOpen: !this.state.isEditImageOpen
              }, () => this._handleToggleEditImageCallback())
            }
          }}
        />
        <Row>
          <Col xs={12} md={6}>
            <Card>
              <CardHeader>
                <FontAwesomeIcon iconType="align-justify"/> {this.props.title}
                {this.props.edit?
                <div>
                  <Link style={{fontSize: '.65rem'}} to="/videos/create">Create new Video</Link>
                </div>
              :null}
              </CardHeader>
              <CardLoadingPlaceholder
                isVisible={isLoading}
                loadingText="Loading..."
              />
              <CardBody>
                { this._renderLoading() }
                { this._renderError() }
                <Row>
                  <Col xs={12}>
                    <Alert
                      color="success"
                      isOpen={this.state._isSuccessSubmitAlertOpen}
                      toggle={()=> this.setState({_isSuccessSubmitAlertOpen: !this.state._isSuccessSubmitAlertOpen})}
                    >
                      <strong>Done!</strong> Submit data successfully.
                    </Alert>
                  </Col>
                </Row>
                <Form onSubmit={this._handleSubmit}>
                  <Row>
                    <Col xs={12}>
                      <FormGroup className={classNames({ 'has-danger has-feedback': this._hasError('name') })}>
                        <Label>Video Name*</Label>
                        <Input
                          placeholder="Enter a name*"
                          name="name"
                          type="text"
                          value={textValue('name', this.state)}
                          onChange={this._handleInputChange}
                        />
                        { this._renderErrorMessage('name') }
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={6}>
                      <FormGroup className={classNames({ 'has-danger has-feedback': this._hasError('category_id') })}>
                        <Label>Category*</Label>
                        <Select
                          name="category_id"
                          value={textValue('category_id', this.state)}
                          options={this.props.categoryOptions.length?
                            this.props.categoryOptions.map(cat => ({ ...cat, label: cat.label.toLowerCase() }))
                            :[{value:'',label:'Loading...'}]}
                          onChange={val => this._handleSelectChange('category_id', val)}
                        />
                        { this._renderErrorMessage('category_id') }
                      </FormGroup>
                    </Col>
                    <Col xs={12} md={6}>
                      <FormGroup className={classNames({ 'has-danger has-feedback': this._hasError('platform') })}>
                        <Label>Visible Only</Label>
                        <Select
                          name="platform"
                          value={textValue('platform', this.state)}
                          options={sliderPlatformOptions}
                          onChange={val => this._handleSelectChange('platform', val)}
                        />
                        { this._renderErrorMessage('platform') }
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row style={{display: 'flex', alignItems: 'flex-end'}}>
                    <Col xs={12} md={6}>
                      <FormGroupRadio className={classNames({ 'has-danger has-feedback': this._hasError('active') })}>
                        <Radio
                          type="checkbox"
                          name="active"
                          value={true}
                          checked={textValue('active', this.state)}
                          dataOnText="Yes"
                          dataOffText="No"
                          onChange={this._handleInputChange}
                        />
                        <RadioText text="Set to Active"/>
                        { this._renderErrorMessage('active') }
                      </FormGroupRadio>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <FormGroup
                        className={classNames({ 'has-danger has-feedback': this._hasError('img_url') })}
                      >
                        <Label>Default Image (Landscape ver.)</Label>
                        <div className="d-flex">
                          <ImageFile
                            style={{padding: 0}}
                            alt="Slider's default image"
                            src={this.state.img_url? this.state.img_url : 'https://via.placeholder.com/300x150?text=1280x400'}
                            showDelete={this.state._rawImage !== null}
                            onDelete={() => {
                              this.setState({
                                img_url: this.state.oldImageUrl,
                                _rawImage: null
                              })
                            }}
                          />
                          <div className="ml-3">
                            <DropzonePlusButton mulitple={false} onDrop={files => this._handleDropzoneChange(files, 'default')}/>
                            <ul className="image-guides" style={{fontSize: '.75rem', marginTop: '.75rem', paddingInlineStart: '1rem'}}>
                              <li className="d-none">You can click the image for preview the image.</li>
                              <li>It will be display on Web only.</li>
                              <li>Use 1280x400 (16:5),  1280x720 (16:9) or  1280x465,45 (11:4) resolution of your image as our recommended. (In pixels).</li>
                              <li>Or any resolution that you want, but make sure its <strong>landscape</strong> orientation.</li>
                              <li className="d-none">If you not provide/upload any images in “Images Form”. By default, this image will be display on our platforms (Web or App).</li>
                              <li className="d-none">By changing the image, click Submit button for save your changes.</li>
                            </ul>
                          </div>
                        </div>
                        { this._renderErrorMessage('img_url') }
                      </FormGroup>
                    </Col>
                  </Row>
                  <Collapse isOpen={visibleOnApp(this.state.platform)}>
                    <Row>
                      <Col xs={12}>
                        <FormGroup
                          className={classNames({ 'has-danger has-feedback': this._hasError('app_image') })}
                        >
                          <Label>App Image (Portrait ver.)</Label>
                          <div className="d-flex">
                            <ImageFile
                              style={{padding: 0}}
                              alt="Slider's app image"
                              src={this.state._appImage? this.state._appImage.imgUrl : 'https://via.placeholder.com/300?text=700x700'}
                              showDelete={this.state._rawImages.length > 0}
                              onDelete={() => {
                                const { _appImage } = this.state;
                                this.setState({
                                  _appImage: _appImage.id > 0?{
                                    ..._appImage,
                                    imgUrl: _appImage.URL
                                  }: null,
                                  _rawImages: []
                                })
                              }}
                            />
                            <div className="ml-3">
                              <DropzonePlusButton mulitple={false} onDrop={files => this._handleDropzoneChange(files, 'app_image')}/>
                              <ul className="image-guides" style={{fontSize: '.75rem', marginTop: '.75rem', paddingInlineStart: '1rem'}}>
                                <li className="d-none">You can click the image for preview the image.</li>
                                <li>It will be display on App only.</li>
                                <li>Use 700x700 (1:1),  700x933,33 (3:4) or  700x1050 (4:6) resolution of your image as our recommended for our app display. (In pixels). Or any resolution that you want, but make sure its <strong>portrait</strong> orientation.</li>
                                <li>If you not provide/upload an image. By default, <strong>Default image</strong> will be display on our platforms (Web or App).</li>
                              </ul>
                            </div>
                          </div>
                          { this._renderErrorMessage('app_image') }
                        </FormGroup>
                      </Col>
                    </Row>
                  </Collapse>
                  <Row>
                    <Col xs={12}>
                      <FormGroup className={classNames({ 'has-danger has-feedback': this._hasError('video_url') })}>
                        <Label>Video Url</Label>
                        <Input
                          name="video_url"
                          placeholder="Example: https://youtu.be/6HR9TpRXcFI"
                          type="text"
                          value={textValue('video_url', this.state)}
                          onChange={this._handleInputChange}
                        />
                        { this._renderErrorMessage('video_url') }
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={6}>
                      <FormGroup className={classNames({ 'has-danger has-feedback': this._hasError('started_at') })}>
                        <Label>Started At</Label>
                        <InputDatetime
                          dateFormat={'DD/MM/YYYY'}
                          inputProps={{placeholder:'Pick a Start Date', name: "started_at", autoComplete: "off"}}
                          value={textValue('started_at', this.state)}
                          onChange={ date => this._handleDatePickerChange(date, 'started_at') }
                          timeFormat={false}
                        />
                        { this._renderErrorMessage('started_at') }
                      </FormGroup>
                    </Col>
                    <Col xs={12} md={6}>
                      <FormGroup className={classNames({ 'has-danger has-feedback': this._hasError('ended_at') })}>
                        <Label>Ended At</Label>
                        <InputDatetime
                          dateFormat={'DD/MM/YYYY'}
                          inputProps={{placeholder:'Pick a End Date', name: "ended_at", autoComplete: "off"}}
                          value={textValue('ended_at', this.state)}
                          onChange={ date => this._handleDatePickerChange(date, 'ended_at') }
                          timeFormat={false}
                        />
                        { this._renderErrorMessage('ended_at') }
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={6}>
                      <FormGroup className={classNames({ 'has-danger has-feedback': this._hasError('order') })}>
                        <Label>Video Position</Label>
                        <Input
                          type="number"
                          id="formOrder"
                          name="order"
                          placeholder="Enter a video position*"
                          value={textValue('order',this.state)}
                          onChange={this._handleInputChange}
                        />
                        { this._renderErrorMessage('order') }
                      </FormGroup>
                    </Col>
                  </Row>
                  {
                    this.state.id > 0 ?(
                      <Row>
                        <Col xs={12} md={6}>
                          <FormGroup>
                            <Label>Created</Label>
                            <Input
                              readOnly
                              name="created_at"
                              type="text"
                              value={textValue('created_at', this.state)}
                            />
                          </FormGroup>
                        </Col>
                        <Col xs={12} md={6}>
                          <FormGroup>
                            <Label>Updated</Label>
                            <Input
                              readOnly
                              name="updated_at"
                              type="text"
                              value={textValue('updated_at', this.state)}
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                    ):null
                  }
                  <p style={{fontSize: '.75rem', fontStyle: 'italic'}}>(*) this field is required.</p>
                  <FormGroup row>
                    <Col>
                      <ButtonGroup>
                        <ButtonLoading
                          disabled={this.state._formSubmit}
                          isLoading={this.state._formSubmit && this.state._submitFormStatus === SUBMIT_SLIDER_FORM_STATUS}
                          loadingMessage="Submitting..."
                          color="primary"
                        >
                            Submit
                        </ButtonLoading>
                        {
                          this.state.id > 0?(
                              <ButtonLoading
                              disabled={this.state._formSubmit}
                              isLoading={this.state._formSubmit && this.state._submitFormStatus === DELETE_SLIDER_FORM_STATUS}
                              loadingMessage="Deleting..."
                              onClick={this._handleModalDeleteToggle}
                              color="danger"
                            >
                                Delete
                            </ButtonLoading>
                          )
                          :null
                        }
                      </ButtonGroup>
                    </Col>
                  </FormGroup>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps= (state) => ({
  slider:state.slider,
  categoryOptions:state.masterCategories.options,
  productVariant: {
    isFetch: state.productVariant.isFetch,
    detail:state.productVariant.detail,
    error: state.productVariant.error
  },
  dataUploaded: state.imageUpload
});

const mapDispatchToProps = (dispatch) => ({
  save:(payload)=>dispatch(saveSlider(payload)),
  new:()=>dispatch(newSlider()),
  find:(id)=>dispatch(getDetailSlider(id)),
  delete:(id,img_url)=>dispatch(deleteSlider(id,img_url)),
  upload: (file, folder, oldFileName)=>dispatch(upload(file,folder, oldFileName)),
  bindCategoryOption:()=>dispatch(getCategoryOptionList()),
  storeSliderImages: (id, payloads) => dispatch(storeSliderImages(id, payloads)),
  uploadImage: (payload, rawImages) => dispatch(uploadImage(payload, rawImages)),
  deleteImage: (payload) => dispatch(deleteImage(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VideoForm);